export enum StickyPosition {
    TOP = 'top',
    RIGHT = 'right',
    BOTTOM = 'bottom',
    LEFT = 'left',
}

export enum PositionType {
    FIXED = 'fixed',
    STICKY = 'sticky',
}
